// src/lib/partner/partnerLearners.js
import { supabase } from "../../supabaseClient";

const EDITABLE_STATUSES = [
  "active",
  "completed",
];

function normaliseEmail(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

function normaliseStatus(value) {
  const status = String(value || "")
    .trim()
    .toLowerCase();

  if (!EDITABLE_STATUSES.includes(status)) {
    throw new Error(
      "Please select a valid learner status."
    );
  }

  return status;
}

export async function fetchPartnerLearners(
  cohortId = null
) {
  const { data, error } = await supabase.rpc(
    "get_my_partner_learners",
    {
      p_cohort_id: cohortId || null,
    }
  );

  if (error) throw error;

  return Array.isArray(data)
    ? data
    : [];
}

export async function addExistingLearnerToCohort({
  cohortId,
  email,
}) {
  const cleanEmail =
    normaliseEmail(email);

  if (!cohortId) {
    throw new Error(
      "Please select a cohort."
    );
  }

  if (!cleanEmail) {
    throw new Error(
      "Please enter the learner's email address."
    );
  }

  const { data, error } = await supabase.rpc(
    "add_existing_learner_to_cohort",
    {
      p_cohort_id: cohortId,
      p_email: cleanEmail,
    }
  );

  if (error) throw error;

  return data;
}

export async function updateCohortLearnerStatus({
  cohortLearnerId,
  status,
}) {
  if (!cohortLearnerId) {
    throw new Error(
      "The cohort learner could not be identified."
    );
  }

  const { data, error } = await supabase.rpc(
    "update_cohort_learner_status",
    {
      p_cohort_learner_id:
        cohortLearnerId,

      p_status:
        normaliseStatus(status),
    }
  );

  if (error) throw error;

  return data;
}

export async function removeLearnerFromCohort(
  cohortLearnerId
) {
  if (!cohortLearnerId) {
    throw new Error(
      "The cohort learner could not be identified."
    );
  }

  const { data, error } = await supabase.rpc(
    "remove_learner_from_cohort",
    {
      p_cohort_learner_id:
        cohortLearnerId,
    }
  );

  if (error) throw error;

  return data === true;
}